import { pushTagManagerEvent } from './tracking';

/**
 * Checks if the request is triggered by a robot
 * Based on Snaptcha https://putyourlightson.com/plugins/snaptcha#ajax-requests
 * @param {Object} event optional event
 * @param {HTMLFormElement} element Root form element
 * @returns {boolean} True if Robot is detected or Snaptcha is not available in form
 * @memberof Form
 */
const detectRobot = async (event: SubmitEvent, element?: HTMLFormElement) => {
  let snaptchaTag: HTMLInputElement | null = null;

  try {
    if (!event) return true;
    event.preventDefault();

    const form = element || event.submitter?.closest('form');
    if (!form) return true;

    snaptchaTag = form.querySelector<HTMLInputElement>(
      'input[name="snaptcha"]'
    );

    if (snaptchaTag) {
      const response = await fetch(
        `/actions/snaptcha/field/validate-field-value?value=${snaptchaTag.value}`,
        {
          headers: {
            Accept: 'application/json'
          }
        }
      );

      const snaptchaResult = await response.json();
      if (!response.ok || !snaptchaResult.success) {
        pushTagManagerEvent('captcha.robot.detected', {
          submitUrl: window.location.href
        });

        if (snaptchaTag) {
          const input = snaptchaTag.closest('.input');
          input?.classList.add('form-error');
        }

        throw Error('Spam detected');
      } else if (snaptchaResult.success) {
        return false;
      }
    }
  } catch (error) {
    console.error('Error:', error);

    pushTagManagerEvent('captcha.robot.detected', {
      submitUrl: window.location.href
    });

    if (snaptchaTag) {
      const input = snaptchaTag.closest('.input');
      input?.classList.add('form-error');
    }
    return true;
  }
};

export default detectRobot;
